export const clientAllPayment = "/client-payment";
export const draftPage = "/client-job/jobstatussection/1";

// Data-driven job wizard. Base path is the "new job" entry (role selector);
// jobWizardPath(projectId) is the resume/edit URL for a specific draft. The
// wizard component (Wizard.tsx) reads :projectId from the route, hydrates the
// server-side draft blob, and resumes at lastVisitedStepId internally - so any
// legacy per-step "edit" routing can just point here.
export const jobWizardBasePath = "/client-profile-job/job-wizard";
export const jobWizardPath = (projectId) =>
    `${jobWizardBasePath}/${projectId}`;
export const hiredPage = "/client-job/jobstatussection/3";
export const openPage = "/client-job/jobstatussection/2";
export const confirmClientOrder = (jobName, jobId, guid, clientId) => `/confirm-order?jobName=${encodeURIComponent(jobName)}&jobId=${jobId}&guid=${guid}&clientId=${clientId}` 
export const signCOCDocument = (jobName, jobId, guid, clientId) => `/sign-coc?jobName=${encodeURIComponent(jobName)}&jobId=${jobId}&guid=${guid}&clientId=${clientId}`
export const signSOWDocument = (guid) => `/sign-sow?docKey=${guid}`
export const signNDADocument = (guid) => `/sign-nda?docKey=${guid}`
export const signMSADocument = (guid) => `/sign-msa?docKey=${guid}`
export const viewProposal = (jobName, jobId) => `/proposal?jobName=${encodeURIComponent(jobName)}&jobId=${jobId}` 